import { render, staticRenderFns } from "./DisplayStoreItemsRegist2.vue?vue&type=template&id=10f084e9&"
import script from "./DisplayStoreItemsRegist2.vue?vue&type=script&lang=js&"
export * from "./DisplayStoreItemsRegist2.vue?vue&type=script&lang=js&"
import style0 from "./DisplayStoreItemsRegist2.vue?vue&type=style&index=0&id=10f084e9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports